import { useVaultPreviewStore } from "~/vaultPreviewStore";

import { VaultPreviewDialog } from "./VaultPreviewDialog";

/** Global vault preview overlay — mounted once in chat so artifact links can open inline. */
export function VaultPreviewHost() {
  const item = useVaultPreviewStore((state) => state.item);
  const open = useVaultPreviewStore((state) => state.open);
  const closePreview = useVaultPreviewStore((state) => state.closePreview);

  return (
    <VaultPreviewDialog
      item={item}
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) closePreview();
      }}
    />
  );
}
